var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7998 17.1C12.9044 17.1 13.7998 16.2046 13.7998 15.1C13.7998 13.9954 12.9044 13.1 11.7998 13.1C10.6952 13.1 9.7998 13.9954 9.7998 15.1C9.7998 16.2046 10.6952 17.1 11.7998 17.1Z",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7998 21.6C21.9044 21.6 22.7998 20.7046 22.7998 19.6C22.7998 18.4954 21.9044 17.6 20.7998 17.6C19.6952 17.6 18.7998 18.4954 18.7998 19.6C18.7998 20.7046 19.6952 21.6 20.7998 21.6Z",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7998 10.5L21.7998 17.6",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 18.5L14.1001 16.3",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4002 16.9L3.7002 25.2",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6001 3.1V25.8",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3001 25.8H3.6001",
    stroke: "#383740",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.7ed3786a74908907c21172ddb462599b.svg";
export { ForwardRef as ReactComponent };